import React, {Component} from 'react';
import PropTypes from "prop-types";
import { withFormik, Form, Field } from 'formik';
import Yup from "yup";
import Record from '../Record';
import moment from 'moment';
import ReactQuill from 'react-quill'; // ES6
import 'react-quill/dist/quill.snow.css'; // ES6

// I choose 'class' (not 'const') because I'll probably will need 'state' in this component after client tells us his demands
class renderQuestionToFrameForm extends Component {

    state = {
        audio: null
    }

    modules = {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
          
            [{ 'header': 1 }, { 'header': 2 }],               // custom button values
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
            [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent                  // text direction
          
            [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown

          
            [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
          
            ['clean']            
        ],
      }
    
      formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote', 'script',
        'list', 'bullet', 'indent',
        'link', 'image', 'color', 'code-block'
      ]

    renderQuestionForm = () => {
        return (
            <div className="col-sm-12">
                <ReactQuill 
                    value={this.props.values.question}
                    modules={this.modules}
                    placeholder={"Write a question"}
                    formats={this.formats}
                    onChange={val => this.props.setFieldValue('question', val)} 
                />
                <br /><br />
            </div>
        )
        
    }

    renderOption = (option, index) => {
        return (
            <div className="col-md-12" key={index}>
                <div className="form-group">
                    <label>Option {option.letter}</label>
                    <ReactQuill 
                        value={this.props.values["option" + option.letter]}
                        modules={this.modules}
                        placeholder={"Write a question"}
                        formats={this.formats}
                        onChange={val => this.props.setFieldValue('option' + option.letter, val)} 
                    />
                </div>
            </div>
        )
    }

    // Send the question to up
    handleSubmit = () =>{
        let question = this.props.questionTemplate;
        question.question = this.props.values.question;
        question.optionA = this.props.values.optionA;
        question.optionB = this.props.values.optionB;
        question.optionC = this.props.values.optionC;
        question.optionD = this.props.values.optionD;
        question.correctOption =this.props.values.correctOption;

        if(this.props.values.time.split(":").length === 3) {
            question.time = moment.duration(this.props.values.time).asSeconds();
        }else if(this.props.values.time.split(":").length === 2){
            question.time = moment.duration("00:" + this.props.values.time).asSeconds()
        }else{
            question.time = moment.duration("00:00:" + this.props.values.time).asSeconds()
        }
        if(this.props.values.answerAt.split(":").length === 3) {
            question.answerAt = moment.duration(this.props.values.answerAt).asSeconds();
        }else if(this.props.values.answerAt.split(":").length === 2){
            question.answerAt = moment.duration("00:" + this.props.values.answerAt).asSeconds()
        }else{
            question.answerAt = moment.duration("00:00:" + this.props.values.answerAt).asSeconds()
        }
        question.answer = this.props.values.answer;
        question.audioUrl = (this.state.audio) ? this.state.audio.url : null;
        question.tag = (question.audioUrl) ? 'Text' : 'MCQ';
        question.name = this.props.values.name;
        question.conceptName = this.props.values.conceptName;

        this.props.onSave(question);
        this.props.triggerModalOpenState();
    }

    renderCorrectOptionForm = () => (
        <div className="col-sm-12">
            <div className="form-group">
                <label>
                    Correct Option
                </label>
                <div className="form-select-overlay">
                    <select 
                        className="form-control"
                        value={this.props.values.correctOption}
                        onChange={e => this.props.setFieldValue('correctOption', e.target.value)}
                        >
                            <option value="1">A</option>
                            <option value="2">B</option>
                            <option value="3">C</option>
                            <option value="4">D</option>
                    </select>
                </div>
                
                {
                    (this.props.touched.correctOption && this.props.errors.correctOption) &&
                    (
                        <p className="help-block">
                            {this.props.errors.correctOption}
                        </p>
                    )
                }
            </div>
        </div>
    );


    //Renders
    renderMultipleChoiceForm = (handleSubmit, touched, errors) => {
        const options = [
            {letter: 'A', number: 1},
            {letter: 'B', number: 2},
            {letter: 'C', number: 3},
            {letter: 'D', number: 4},
        ]
        return (
            <div
                className="tab-pane no-padding active"
                id="MultipleChoiceTab"
            >
                <div className="sp-20">
                    <div className="row">
                        <div className="col-sm-3">
                            <div className="form-group">
                                <label>
                                    Concept Name:
                                </label>
                                <Field
                                    type="text"
                                    className="form-control"
                                    name='conceptName'
                                />
                                {
                                    (touched.conceptName && errors.conceptName) &&
                                    (
                                        <p className="help-block">
                                            {errors.conceptName}
                                        </p>
                                    )
                                }
                            </div>
                        </div>

                        <div className="col-sm-3">
                            <div className="form-group">
                                <label>
                                    Objective Name:
                                </label>
                                <Field
                                    type="text"
                                    className="form-control"
                                    name='name'
                                />

                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="form-group">
                                <label>
                                    Time In Video
                                </label>
                                <Field
                                    name='time'
                                    type="text"
                                    className="form-control"
                                />
                                {
                                    (touched.time && errors.time) &&
                                    (
                                        <p className="help-block">
                                            {errors.time}
                                        </p>
                                    )
                                }
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="form-group">
                                <label>
                                    Concept Refers To
                                </label>
                                <Field
                                    type="text"
                                    className="form-control"
                                    name='answerAt'
                                />
                                {
                                    (touched.answerAt && errors.answerAt) &&
                                    (
                                        <p className="help-block">
                                            {errors.answerAt}
                                        </p>
                                    )
                                }
                            </div>
                        </div>
                        
                        {this.renderQuestionForm()}
                        {options.map((option, i) => {
                            return this.renderOption(option, i)
                        })}
                        
                        {this.renderCorrectOptionForm()}
                    </div>
                </div>
                <div className="text-right bg-dd sp-10">
                    <a
                        className="btn btn-default"
                        data-dismiss="modal"
                        onClick={this.props.triggerModalOpenState}
                    >
                        Cancel
                    </a>
                    <a
                        className="btn btn-base"
                        onClick={this.handleSubmit}
                    >
                        Save Changes
                    </a>
                </div>
            </div>
        )
    };

    // this form (renderTextBasedQuestionForm) will be changed according to customer requirements.
    // Right now is just a test version. Do not check it
    renderTextBasedQuestionForm = (handleSubmit, recordingDone, setFieldValue, touched, errors) => {
        return (
            <div className="tab-pane text-based-tab" id="TextBasedQuestionTab">
                <div className="sp-20">
                    <div className="row">
                        <div className="col-sm-8">
                            <div className="form-group">
                                <label>Concept Name:</label>
                                <Field type="text"
                                       name='conceptName'
                                       placeholder="e.g. Gravity"
                                       className="form-control"/>
                            </div>

                            <div className="form-group">
                                <label>
                                    Objective Name:
                                </label>
                                <Field
                                    type="text"
                                    className="form-control"
                                    name='name'
                                />

                            </div>
                        </div>

                        <div className="col-sm-4 overflow-hidden">
                            <div className="form-group">

                                <Record user={this.props.user} recordingFinished={(data) => {
                                    recordingDone(data);
                                    setFieldValue("question", data.text, false);
                                }} />

                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Answer at (in seconds)</label>
                                <Field type="text"
                                       name="answerAt"
                                       placeholder="example: 45"
                                       className="form-control"/>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Time In Video</label>
                                <Field
                                    type="text"
                                    name='time'
                                    // value="120"
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label>Question</label>
                                <Field
                                    type="text"
                                    className="form-control"
                                    name="question" />
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label>Answer Choices (Each choice should be in its seperate
                                    line)</label>
                                <Field
                                    className="form-control"

                                    name="answer"
                                    placeholder="e.g. Option 1
                                                            Option 2
                                                            Option 3"
                                   />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="text-right bg-dd sp-10">
                    <a
                        className="btn btn-default"
                        data-dismiss="modal"
                        onClick={this.props.triggerModalOpenState}
                    >
                        Cancel
                    </a>
                    <a
                        // href="#"
                        className="btn btn-base"
                    onClick={this.handleSubmit}>
                        Save Changes
                    </a>
                </div>
            </div>
        )
    };

    recordingDone = (data) => {
        this.setState({audio: data});

    }

    render () {
        const {
            handleSubmit,
            touched,
            errors,
            selectedTabName,
            setFieldValue
        } = this.props;

        return (
            <Form className="tab-content no-padding">

                {
                    selectedTabName === 'multiple' &&
                    this.renderMultipleChoiceForm(handleSubmit, touched, errors)
                }
                {
                    selectedTabName === 'textBased' &&
                    this.renderTextBasedQuestionForm(handleSubmit, this.recordingDone, setFieldValue, touched, errors)
                }
            </Form>
        )
    }
}


const AddQuestionToFrameForm = withFormik({
    mapPropsToValues({
        questionTemplate,
                         conceptName,
                         time,
                         answerAt,
                         question,
                         optionA,
                         optionB,
                         optionC,
                         optionD,
                        name,
                        answer,
                         correctOption
                     })
    {

        if(questionTemplate.time) {
            if (questionTemplate.time >= 3660) {
                time = moment.utc(questionTemplate.time * 1000).format('HH:mm:ss');
            } else if (questionTemplate.time >= 60) {
                time = moment.utc(questionTemplate.time * 1000).format('mm:ss');
            } else {
                time = moment.utc(questionTemplate.time * 1000).format('mm:ss');
            }
        }else{
            time = "00:00:00";
        }

        if(questionTemplate.answerAt >= 3660){
            answerAt = moment.utc(questionTemplate.answerAt*1000).format('HH:mm:ss');
        }else if(questionTemplate.answerAt >= 60){
            answerAt = moment.utc(questionTemplate.answerAt*1000).format('mm:ss');
        }else{
            answerAt = moment.utc(questionTemplate.answerAt*1000).format('mm:ss');
        }
        return {
            conceptName: conceptName || questionTemplate.conceptName || '',
            name: name || questionTemplate.name || '',
            time: time || '',
            answerAt: answerAt || '',
            question: questionTemplate.question || '',
            optionA: optionA || questionTemplate.optionA || '',
            optionB: optionB || questionTemplate.optionB || '',
            optionC: optionC || questionTemplate.optionC || '',
            optionD: optionD || questionTemplate.optionD || '',
            answer: questionTemplate.answer || '',
            correctOption: correctOption || questionTemplate.correctOption || 1
        };
    },

    validationSchema: Yup.object().shape({
        conceptName: Yup.string().required('concept Name is required'),
        timeInVideo: Yup.string().required('timeInVideo is required'),
        answerAt: Yup.string().required('conceptRefersTo is required'),
        question: Yup.string().min(2, 'Question is too short').required('Question is required'),
        optionA: Yup.string().required('optionA is required'),
        optionB: Yup.string().required('optionB is required'),
        correctOption: Yup.number('correct Option must be a number').required('Choose correct Option'),
    }),

    updateQuestionFromAudio(audioText, {setFieldValue, props}){
        setFieldValue("question", audioText, false);
    },



    handleSubmit(values, {setErrors, props}) {
        setTimeout(() => {
            if (values.email === 'test@test.io') {
                setErrors({ email: 'This email is already token' })
            }
            else {
                if (props.selectedTabName === "multiple") {

                    props.triggerModalOpenState();
                } else {
                    // this condition will be fulfilled after client gives his requirement
                }
            }
        }, 200)
    }

})(renderQuestionToFrameForm);


AddQuestionToFrameForm.propTypes = {
    selectedTabName: PropTypes.string.isRequired,
    triggerModalOpenState: PropTypes.func.isRequired
};

export default AddQuestionToFrameForm;


// WEBPACK FOOTER //
// ./src/components/EditChapterPart/FormModals/AddQuestionToFrameForm.js